import { action } from 'typesafe-actions';
// eslint-disable-next-line no-unused-vars
import { NotificationInterface, NotificationsTypes } from './types';

// List Notifications
export const listNotificationsRequest = (payload: {
  body?: object;
  filtering?: boolean;
}) => action(NotificationsTypes.LIST_NOTIFICATIONS_REQUEST, payload);
export const listNotificationsSuccess = (payload: {
  notifications: NotificationInterface[];
  totalCount: number;
}) => action(NotificationsTypes.LIST_NOTIFICATIONS_SUCCESS, payload);
export const listNotificationsFailure = () =>
  action(NotificationsTypes.LIST_NOTIFICATIONS_FAILURE);

// Get Notification
export const getNotificationRequest = (payload: object) =>
  action(NotificationsTypes.GET_NOTIFICATION_REQUEST, payload);
export const getNotificationSuccess = (payload: {
  notificationData: NotificationInterface;
}) => action(NotificationsTypes.GET_NOTIFICATION_SUCCESS, payload);
export const getNotificationFailure = () =>
  action(NotificationsTypes.GET_NOTIFICATION_FAILURE);

// Create Notification
export const createNotificationRequest = (payload: object) =>
  action(NotificationsTypes.CREATE_NOTIFICATION_REQUEST, payload);
export const createNotificationSuccess = () =>
  action(NotificationsTypes.CREATE_NOTIFICATION_SUCCESS);
export const createNotificationFailure = () =>
  action(NotificationsTypes.CREATE_NOTIFICATION_FAILURE);

// Update Notification
export const updateNotificationRequest = (payload: object) =>
  action(NotificationsTypes.UPDATE_NOTIFICATION_REQUEST, payload);
export const updateNotificationSuccess = () =>
  action(NotificationsTypes.UPDATE_NOTIFICATION_SUCCESS);
export const updateNotificationFailure = () =>
  action(NotificationsTypes.UPDATE_NOTIFICATION_FAILURE);

// Delete Notification
export const deleteNotificationRequest = (payload: object) =>
  action(NotificationsTypes.DELETE_NOTIFICATION_REQUEST, payload);
export const deleteNotificationSuccess = () =>
  action(NotificationsTypes.DELETE_NOTIFICATION_SUCCESS);
export const deleteNotificationFailure = () =>
  action(NotificationsTypes.DELETE_NOTIFICATION_FAILURE);

// Create Notifications
export const createNotificationsRequest = (payload: Array<object>) =>
  action(NotificationsTypes.CREATE_NOTIFICATIONS_REQUEST, payload);
export const createNotificationsSuccess = () =>
  action(NotificationsTypes.CREATE_NOTIFICATIONS_SUCCESS);
export const createNotificationsFailure = () =>
  action(NotificationsTypes.CREATE_NOTIFICATIONS_FAILURE);

// Update Notifications
export const updateNotificationsRequest = (payload: object) =>
  action(NotificationsTypes.UPDATE_NOTIFICATIONS_REQUEST, payload);
export const updateNotificationsSuccess = () =>
  action(NotificationsTypes.UPDATE_NOTIFICATIONS_SUCCESS);
export const updateNotificationsFailure = () =>
  action(NotificationsTypes.UPDATE_NOTIFICATIONS_FAILURE);

// Delete Notifications
export const deleteNotificationsRequest = (payload: object) =>
  action(NotificationsTypes.DELETE_NOTIFICATIONS_REQUEST, payload);
export const deleteNotificationsSuccess = () =>
  action(NotificationsTypes.DELETE_NOTIFICATIONS_SUCCESS);
export const deleteNotificationsFailure = () =>
  action(NotificationsTypes.DELETE_NOTIFICATIONS_FAILURE);
